<div [formGroup]="form">
  <div class="form-group" [class.hidden]="hideAcn">
    <app-masked-input
      placeholder="___ ___ ___"
      formControlName="acn"
      [label]="acnTitle"
      [customErrors]="{ required: 'ACN is required.' }"
      [mask]="'___ ___ ___'"
      (focusout)="onAcnInputBlur()"
    />
  </div>

  <div class="hide-empty"><ng-content/></div>

  <div class="form-group">
    <app-integrations-entity-search-control
      formControlName="name"
      [entityType]="entityType"
      [allowedSources]="allowedSources"
      [customErrors]="{ required: 'Name is required.', minLength: 'Company name does not seem to be valid.' }"
      (companySelected)="onCompanySelected($event)"
    />

    @if (shouldLookForCompanyName && cantFindCompanyName && form.controls.name.invalid) {
      <div class="helper error">Can't find company name by ACN. Please enter it manually.</div>
    }
  </div>
</div>
